function extractTimeFromUTC(utcString: string = ''): string {
	if (!utcString.includes('T')) {
		return utcString;
	}

	return utcString.split('T')[1]?.slice(0, 5) || '';
}

export default extractTimeFromUTC;
